<template>
  <nav class="navbar">
    <div class="nav-container">
      <!-- Logo -->
      <router-link to="/" class="nav-logo">KS</router-link>

      <!-- Hamburger Icon -->
      <div class="nav-toggle" @click="toggleMenu">
        <span class="line" :class="{ open: menuOpen }"></span>
        <span class="line" :class="{ open: menuOpen }"></span>
      </div>

      <!-- Desktop Navigation -->
      <ul class="nav-links">
        <li><router-link to="/">HOME</router-link></li>
        <li><a href="https://krilinschmid.mypixieset.com">GALERIE</a></li>
        <li><router-link to="/about">ÜBER MICH</router-link></li>
        <li><router-link to="/contact">KONTAKT</router-link></li>
      </ul>
    </div>

    <!-- Mobile Fullscreen Menu -->
    <div class="mobile-menu" :class="{ open: menuOpen }">
      <div class="close-icon" @click="closeMenu">×</div>

      <ul>
        <li><router-link to="/" @click="closeMenu">HOME</router-link></li>
        <li><a href="https://krilinschmid.mypixieset.com" @click="closeMenu">GALERIE</a></li>
        <li><router-link to="/about" @click="closeMenu">ÜBER MICH</router-link></li>
        <li><router-link to="/contact" @click="closeMenu">KONTAKT</router-link></li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      menuOpen: false
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    }
  }
};
</script>

<style scoped>
/* ===========================
   GENERAL NAVBAR STYLING
=========================== */

.navbar {
  width: 100%;
  background: #262626;
  color: #D6D1CE;
  position: fixed;
  top: 0;
  z-index: 200;
  height: 90px;
}

.nav-container {
  max-width: 2090px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
}

/* Logo */
.nav-logo {
  font-size: 2.4rem;
  font-weight: 600;
  text-decoration: none;
  color: #D6D1CE;
  letter-spacing: 2px;
}

.nav-logo:hover {
  color: var(--accent);
}

/* Desktop Navigation */
.nav-links {
  display: flex;
  gap: 45px;
  list-style: none;
}

.nav-links li a {
  color: #D6D1CE;
  text-decoration: none;
  font-size: 0.95rem;
  letter-spacing: 3px;
  transition: opacity 0.2s ease;
}

.nav-links li a:hover {
  opacity: 0.6;
  color: var(--accent);
}

/* ===========================
   HAMBURGER / MOBILE ICON
=========================== */

.nav-toggle {
  display: none;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
}

.line {
  width: 32px;
  height: 3px;
  background: #ffffff;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

/* Hamburger animation */
.line:first-child.open {
  transform: translateY(5px) rotate(45deg);
}

.line:last-child.open {
  transform: translateY(-5px) rotate(-45deg);
}

/* ===========================
   MOBILE FULLSCREEN MENU
=========================== */

.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #2F2E2E;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.mobile-menu.open {
  opacity: 1;
  pointer-events: auto;
}

/* Close icon */
.close-icon {
  position: absolute;
  top: 40px;
  right: 40px;
  font-size: 2.8rem;
  color: #e0a458;
  cursor: pointer;
}

/* Mobile Menu Links */
.mobile-menu ul {
  list-style: none;
  text-align: center;
}

.mobile-menu li {
  margin: 30px 0;
}

.mobile-menu a {
  color: #e0a458;
  font-size: 1.5rem;
  letter-spacing: 4px;
  text-decoration: none;
}

/* ===========================
   RESPONSIVE
=========================== */

@media (max-width: 900px) {
  .nav-links {
    display: none;
  }

  .nav-toggle {
    display: flex;
  }
}
</style>
